module.exports = __webpack_public_path__ + "img/img_yunda@2x.5035e8bf.png";